import { Circle } from '@mui/icons-material'
import BlinkingComponent from './BlinkingComponent'
import { SvgIconProps, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

/**
 * The props of the status indicator.
 */
interface StatusIndicatorProps extends SvgIconProps {
  /**
   * The status.
   */
  status: boolean
}

/**
 * A status indicator.
 */
export default function StatusIndicator({
  status,
  fontSize = 'inherit',
  ...props
}: StatusIndicatorProps): JSX.Element {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  return (
    <>
      {status ? (
        <Tooltip title={t('online')}>
          <Circle color="success" fontSize={fontSize} {...props} />
        </Tooltip>
      ) : (
        <Tooltip title={t('offline')}>
          <BlinkingComponent>
            <Circle color="error" fontSize={fontSize} {...props} />
          </BlinkingComponent>
        </Tooltip>
      )}
    </>
  )
}
